<div class="container-fluid campaign-background pt-0">
  <app-trial-license-warning></app-trial-license-warning>
  <lib-campaigns></lib-campaigns>
</div>

<div class="content-section">
  <div class="title-div">
    <div class="col p-0 d-flex justify-content-between align-items-center changeInstitution">
      <div class="col-11 p-0">
        <a class="back_bd" (click)="backToManageUser()">
          <img class="svg mr-2" src="assets/ph-bhp-layout/svg/back.svg" />
          {{ translationKeys.SOPObservation.Back | translate}}</a>

        <h2 class="background_title">
          {{ "USER_MANAGEMENT.VIEW_USER" | translate }}
        </h2>
      </div>
      <div class="col-auto d-flex justify-content-md-end justify-content-sm-start">
        <div class="col-auto institution-name pl-0">
          <!-- <img alt="Institution" src="assets/img/svg/icon-help.svg"> -->
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid alone">
    <form class="form-container" name="addUserFormGeneralInfo" [formGroup]="addUserFormGeneralInfo">
      <div class="mx-4 user-container">
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <div class="form-group">
              <label for="name">{{
                translationKeys.ProfileDetails.Name | translate
                }}</label>

              <p style="margin-bottom: 0px; line-height: 24px">
                {{ newUser ? newUser.name : ("" | translate) }}
              </p>
            </div>
          </div>
          <div class="col-md-6 col-sm-12" style="display: none">
            <div class="form-group">
              <label for="isActive">{{
                "INSTITUTION_MANAGEMENT.STATUS" | translate
                }}</label>
              <label class="switch mb-4 mt-2 d-block">
                <input class="form-control" type="checkbox" name="isActive" formControlName="isActive" disabled />
                <span class="slider round"></span>
                <span class="status active">{{
                  "INSTITUTION_MANAGEMENT.YES" | translate
                  }}</span>
                <span class="status inactive">{{
                  "INSTITUTION_MANAGEMENT.NO" | translate
                  }}</span>
              </label>
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="form-group">
              <label for="email">{{
                translationKeys.ProfileDetails.Email | translate
                }}</label>
              <p style="margin-bottom: 0px; line-height: 24px">
                {{ newUser ? newUser.email : ("" | translate) }}
              </p>
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="form-group">
              <label for="username">{{
                translationKeys.Authorization.Username | translate
                }}</label>
              <p style="margin-bottom: 0px; line-height: 24px">
                {{ newUser ? newUser.username : ("" | translate) }}
              </p>
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="form-group">
              <label for="roleId">{{
                translationKeys.ProfileDetails.Role | translate
                }}</label>
              <p style="margin-bottom: 0px; line-height: 24px">
                {{ roleName | translate }}
              </p>
            </div>
          </div>

          <div class="col-md-4 col-sm-12">
            <div class="form-group" *ngIf="addUserFormGeneralInfo.value.roleId != ''">
              <label>{{
                translationKeys.ProfileDetails.InstitutionName | translate
                }}</label>
              <div class="mb-2">
                <p *ngFor="let institution of roleAndInstitutionsList[0].institutions">
                  {{ institution.institutionName }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="side-appbar">
  <div class="container-fluid"></div>
</div>

<div id="page_overlay"></div>